interface FilterOption {
  value: string | number;
  label: string;
}

export function describeFilterOptions(values: Array<string | number>, options: FilterOption[]): string[] {
  return values.map((value) => {
    const option = options.find((candidate) => String(candidate.value) === String(value));
    if (!option || option.label === String(value)) return String(value);
    return `${option.label} (id ${value})`;
  });
}
